module.exports = __webpack_public_path__ + "img/iva_diferencia.d93c03ab.png";